__turbopack_context__.v({
  "divider": "styles-module-scss-module__gFxrqW__divider",
  "marketplacesRow": "styles-module-scss-module__gFxrqW__marketplacesRow",
  "mutedValue": "styles-module-scss-module__gFxrqW__mutedValue",
  "statItem": "styles-module-scss-module__gFxrqW__statItem",
  "statLabel": "styles-module-scss-module__gFxrqW__statLabel",
  "statValue": "styles-module-scss-module__gFxrqW__statValue",
  "statsBar": "styles-module-scss-module__gFxrqW__statsBar",
  "statsContainer": "styles-module-scss-module__gFxrqW__statsContainer",
  "vendorLink": "styles-module-scss-module__gFxrqW__vendorLink",
});
